var r="4.22.0";export{r as version};
//# sourceMappingURL=package.json.js.map
